var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titles"},_vm._l((_vm.titles),function(item,index){return _c('t-list-item',{key:index,style:({color : (index === 0) ? '#262626' : '#595959', 'font-weight' : (index === 0) ? 'blod' : ''}),attrs:{"titles-item":item,"titles-index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }